import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import pic from "./ImageNotFound.png";
import constantURI from "../URI"
import _post from "../Functions/Post"
import SearchFilterFunction from "../Functions/SearchFilter"
import stylesMed from "./stylesMed"
import Loading from "../Loading"
import Authenticate from "../Functions/MedRepAuthenticate"

export default class Products extends React.Component {

    constructor() {
        super();
        this.state = {
            products: [],
            productsCopy: [],
            loading: true,
            noData: true,
            user: "",
            token: "",
            prods: [],
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const user = localStorage.getItem("User");
        const token = localStorage.getItem("Token");
        await this.setState({ user: JSON.parse(user), token: JSON.parse(token) });

        const productsURL = constantURI() + "odooController/MedRepRead";
        const productsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "product.product",
                args: [],
                kwargs: {
                    fields: ["default_code", "name"]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(productsURL, productsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ prods: data.result })
                        localStorage.setItem('ProductsList', JSON.stringify(this.state.prods));
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const prods = localStorage.getItem('ProductsList');
            this.setState({ prods: JSON.parse(prods) });
        }
        const productsStockBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "x_stock",
                args: [],
                kwargs: {
                    fields: ["x_product_id", "remaining_stock"],
                    domain: [["x_partner_id", "=", this.state.user]],
                    limit: this.state.prods.length,
                    offset: 0,
                    order: "create_date DESC"
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(productsURL, productsStockBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ products: data.result, productsCopy: data.result, loading: false })
                        localStorage.setItem('Products', JSON.stringify(this.state.products));
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const products = localStorage.getItem('Products');
            this.setState({ products: JSON.parse(products), productsCopy: JSON.parse(products), loading: false });
        }
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.products, this.state.productsCopy, this.state.noData);
        this.setState({ products: values.items, noData: values.noData })
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="pt-3">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="pt-3">
                        <input type="text" className="form-control" placeholder="Search Here" onInput={text => this.onSearch(text)} />
                    </div>
                    <p className="pt-3 text-center h3">Product List</p>
                    <div className="pt-2">
                        <div className="row">
                            {this.state.products.map((item, index) => {
                                return (
                                    <div className="col-sm-6 pt-3" key={index}>
                                        <div className="card-body bg-light">
                                            <div className="text-center">
                                                <img src={pic} style={stylesMed.productCard} alt="Not found" />
                                            </div>
                                            <h3 className="pt-2">{item.x_product_id[1]}</h3>
                                            <h5>Amount Left: {item.remaining_stock}</h5>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div >
            );
        }
        else {
            return (
                <Loading history={this.props.history} page={"./LandingPageRep"} name={"Product"}></Loading>
            )
        }
    }
}

